import { connect } from 'react-redux';
import { menuItems, menuExtraItems } from '../defaults/menuItems';
// Components
import Menu from '../components/layout/nav/menu/Menu';

const mapStateToProps = (state) => {
  return {
    locale: state.localeSelector,
    items: menuItems,
    extra: menuExtraItems,
  };
};

const MenuContainer = connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(Menu);

export default MenuContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/MenuContainer.js
 **/